import { AvatarListPageContext, AvatarListPageContextType } from '@/pages/avatar/ListPage/contex/AvatarListPageContext';
import { useContext } from 'react';

export const useAvatarListPageContext = (): AvatarListPageContextType => {
    const context = useContext(AvatarListPageContext);

    if (!context) {
        throw new Error('useAvatarListPageContext must be used within a AvatarListPageContextProvider');
    }

    return context;
};
